module.exports = __webpack_public_path__ + "img/MediaBoard.0719c7d3.png";